import { Navigate, useParams } from "react-router-dom-v5-compat";

import { toDateString } from "@megaron/date-string";
import { getMegaraxPath, VisitView } from "@megaron/megarax-uri";

type Props = {
  view?: VisitView;
};

export const VisitsRedirect = ({ view }: Props) => {
  const { userId } = useParams<{ userId: string }>();

  if (!userId) {
    return null;
  }

  if (!view) {
    return (
      <Navigate
        to={getMegaraxPath.uri("megarax://crm/salesperson-visits/id/{id}/{view}", { id: userId, view: "week" })}
        replace
      />
    );
  }

  return (
    <Navigate
      to={getMegaraxPath.uri("megarax://crm/salesperson-visits/id/{id}/{view}/{date}", {
        id: userId,
        view,
        date: toDateString(new Date()),
      })}
      replace
    />
  );
};
